export default {
  bookingConfirmation: 'booking-confirmation',
  welcomeEmail:        'welcome-email',
  winBackSequence:     'win-back-sequence'
};
